<template>
<div
  class="action-alert pointer-events-none fixed inset-x-0 top-[3.125rem] z-(--z-toast) flex justify-center
         max-sm:top-(--mobile-header-height)"
  key="action-alert"
>
  <div
    class="alert-container popover-panel pointer-events-auto flex max-w-125 items-center
           justify-between gap-5 px-6 py-4
           max-sm:max-w-[100vw] max-sm:flex-col max-sm:justify-center max-sm:px-5 max-sm:text-center"
    key="alert-container"
    @mouseenter="confirmButtonEl.stopCountdown()"
  >
    <div class="action-text max-w-[17.8125rem] text-body text-text [&_i]:break-all">
      <span v-html="actionText"></span>
    </div>
    <div class="action-btns flex gap-2.5 max-sm:mt-2.5">
      <SimpleButton
        v-if="grayButton"
        :text="grayButton.text"
        @click="grayButton.method"
      />
      <SimpleButton
        v-if="confirmButton"
        ref="confirmButtonEl"
        :text="confirmButton.text"
        :autoClickAfter="5"
        :variant="confirmButton.variant"
        @click="confirmButton.method"
      />
    </div>
  </div>
</div>
</template>

<script setup>
import { ref } from 'vue';
import SimpleButton from '@/components/elements/SimpleButton';

// hovering the alert means reading it: its auto-click waits for the user
const confirmButtonEl = ref(null);

defineProps({
  grayButton: Object,
  confirmButton: Object,
  actionText: {
    type: String,
    default: '',
  },
});
</script>
